import { useAtomValue } from 'jotai';
import { rawUserDetailsAtom } from '@/atoms/queries/user';
import { canUserSeeAlphaTestingFeatures, canUserSeeDevTeamFeatures } from '@/utils/user';

/**
 * Base hooks for feature flags — do not use these directly outside of src/hooks/featureFlags/.
 *
 * Instead, create a named hook in a new file in this directory and export it from index.ts:
 *
 * export const useShowYourFeature = useShouldShowAlphaTestingFeature; // or useShouldShowDevTeamFeature
 *
 * This makes toggling the feature fully on and cleaning up after launch a single-file change.
 */
export const useShouldShowAlphaTestingFeature = () => {
  const userDetails = useAtomValue(rawUserDetailsAtom).data;
  return canUserSeeAlphaTestingFeatures(userDetails);
};

export const useShouldShowDevTeamFeature = () => {
  const userDetails = useAtomValue(rawUserDetailsAtom).data;
  return canUserSeeDevTeamFeatures(userDetails);
};
